import { create } from "zustand";

const RoleManagementStore = create((set) => ({
  roles: [],
  isLoading: false,
  error: null,

  getAuthHeaders: () => {
    const token = localStorage.getItem("token");
    const tenantId = localStorage.getItem("tenantId");
    const role = localStorage.getItem("role");

    if (!token) {
      console.error("No token found in localStorage");
      return {
        headers: {
          "Content-Type": "application/json",
          Authorization: "",
        },
        params: "",
      };
    }

    const params = new URLSearchParams();
    if (tenantId && tenantId !== "null" && role !== "SuperAdmin") {
      params.append("tenantId", tenantId);
    }
    if (role === "SuperAdmin") {
      params.append("allTenants", "true");
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    console.log(
      "getAuthHeaders - Constructed headers:",
      headers,
      "Params:",
      params.toString()
    );

    return {
      headers,
      params: params.toString(),
    };
  },

  fetchRoles: async (tenantId = null) => {
    set({ isLoading: true, error: null });
    try {
      let params;
      const { headers } = RoleManagementStore.getState().getAuthHeaders();

      // If a tenantId is provided (e.g., for CustomerAdmin), override the default params
      if (tenantId) {
        params = new URLSearchParams();
        params.append("tenantId", tenantId);
      } else {
        // Otherwise, use the default getAuthHeaders logic
        const authHeaders = RoleManagementStore.getState().getAuthHeaders();
        params = authHeaders.params;
      }

      const url = `${process.env.REACT_APP_API_URL}api/role/getroles${params ? `?${params}` : ""}`;
      const fetchHeaders = new Headers();
      fetchHeaders.append("Content-Type", headers["Content-Type"]);
      fetchHeaders.append("Authorization", headers.Authorization);

      const response = await fetch(url, {
        method: "GET",
        headers: fetchHeaders,
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Fetch roles error response:", errorText);
        throw new Error("Failed to fetch roles");
      }

      const data = await response.json();
      set({ roles: data.roles || [], isLoading: false });
    } catch (error) {
      set({ error: error.message || "Failed to fetch roles", isLoading: false });
      console.error("Error fetching roles:", error);
    }
  },

  addRole: async (roleData) => {
    set({ isLoading: true, error: null });
    try {
      const { headers, params } = RoleManagementStore.getState().getAuthHeaders();
      const role = localStorage.getItem("role");
      const rolePayload = { ...roleData };

      console.log("addRole - Payload:", rolePayload, "User Role:", role);

      const url = `${process.env.REACT_APP_API_URL}api/role/createrole${params ? `?${params}` : ""}`;
      const fetchHeaders = new Headers();
      fetchHeaders.append("Content-Type", headers["Content-Type"]);
      fetchHeaders.append("Authorization", headers.Authorization);

      const response = await fetch(url, {
        method: "POST",
        headers: fetchHeaders,
        body: JSON.stringify(rolePayload),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Add role error response:", errorText);
        const errorData = JSON.parse(errorText);
        throw new Error(errorData.message || "Failed to add role");
      }

      const data = await response.json();
      set((state) => ({
        roles: [...state.roles, data.role],
        isLoading: false,
        error: null,
      }));
      return data;
    } catch (error) {
      set({ error: error.message || "Failed to add role", isLoading: false });
      console.error("Error adding role:", error);
      throw error;
    }
  },

  updateRole: async (roleId, roleData) => {
    set({ isLoading: true, error: null });
    try {
      const { headers, params } = RoleManagementStore.getState().getAuthHeaders();
      const rolePayload = { ...roleData };

      const url = `${process.env.REACT_APP_API_URL}api/role/updaterole/${roleId}${params ? `?${params}` : ""}`;
      const fetchHeaders = new Headers();
      fetchHeaders.append("Content-Type", headers["Content-Type"]);
      fetchHeaders.append("Authorization", headers.Authorization);

      const response = await fetch(url, {
        method: "PUT",
        headers: fetchHeaders,
        body: JSON.stringify(rolePayload),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Update role error response:", errorText);
        throw new Error("Failed to update role");
      }

      const data = await response.json();
      set((state) => ({
        roles: state.roles.map((role) => (role._id === roleId ? data.role : role)),
        isLoading: false,
        error: null,
      }));
      return data;
    } catch (error) {
      set({ error: error.message || "Failed to update role", isLoading: false });
      console.error("Error updating role:", error);
      throw error;
    }
  },

  deleteRole: async (roleId) => {
    set({ isLoading: true, error: null });
    try {
      const { headers, params } = RoleManagementStore.getState().getAuthHeaders();
      const url = `${process.env.REACT_APP_API_URL}api/role/deleterole/${roleId}${params ? `?${params}` : ""}`;
      const fetchHeaders = new Headers();
      fetchHeaders.append("Content-Type", headers["Content-Type"]);
      fetchHeaders.append("Authorization", headers.Authorization);

      const response = await fetch(url, {
        method: "DELETE",
        headers: fetchHeaders,
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Delete role error response:", errorText);
        throw new Error("Failed to delete role");
      }

      set((state) => ({
        roles: state.roles.filter((role) => role._id !== roleId),
        isLoading: false,
        error: null,
      }));
      return await response.json();
    } catch (error) {
      set({ error: error.message || "Failed to delete role", isLoading: false });
      console.error("Error deleting role:", error);
      throw error;
    }
  },
}));

export default RoleManagementStore;